var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"copy-btn fa fa-fw fa-copy",attrs:{"title":"Click to copy"},on:{"click":_vm.onClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }